import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarSparkle = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 17 17",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.1243 10.8333C7.06478 10.6026 6.94453 10.3921 6.77605 10.2236C6.60757 10.0551 6.39702 9.93485 6.1663 9.87533L2.0763 8.82066C2.00652 8.80085 1.94511 8.75883 1.90138 8.70096C1.85765 8.64309 1.83398 8.57253 1.83398 8.49999C1.83398 8.42746 1.85765 8.3569 1.90138 8.29903C1.94511 8.24116 2.00652 8.19913 2.0763 8.17933L6.1663 7.12399C6.39693 7.06453 6.60743 6.94438 6.7759 6.77602C6.94438 6.60766 7.06468 6.39725 7.1243 6.16666L8.17897 2.07666C8.19857 2.00661 8.24056 1.94489 8.29851 1.90092C8.35647 1.85696 8.42722 1.83316 8.49997 1.83316C8.57271 1.83316 8.64346 1.85696 8.70142 1.90092C8.75938 1.94489 8.80136 2.00661 8.82097 2.07666L9.87497 6.16666C9.93449 6.39737 10.0547 6.60792 10.2232 6.77641C10.3917 6.94489 10.6023 7.06514 10.833 7.12466L14.923 8.17866C14.9933 8.19806 15.0553 8.24 15.0995 8.29804C15.1437 8.35609 15.1677 8.42703 15.1677 8.49999C15.1677 8.57295 15.1437 8.6439 15.0995 8.70194C15.0553 8.75999 14.9933 8.80193 14.923 8.82133L10.833 9.87533C10.6023 9.93485 10.3917 10.0551 10.2232 10.2236C10.0547 10.3921 9.93449 10.6026 9.87497 10.8333L8.8203 14.9233C8.8007 14.9934 8.75871 15.0551 8.70075 15.0991C8.6428 15.143 8.57205 15.1668 8.4993 15.1668C8.42656 15.1668 8.35581 15.143 8.29785 15.0991C8.23989 15.0551 8.19791 14.9934 8.1783 14.9233L7.1243 10.8333Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.834 2.5V5.16667",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1667 3.83333H12.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.16602 11.8333V13.1667",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.83333 12.5H2.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgStarSparkle;
